var _style, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgButcher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 285 263",
    style: {
      enableBackground: "new 0 0 285 263"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;}\n\t.st1{opacity:0.8;fill:url(#Path_671_00000046304187348123976590000016517492087787889072_);enable-background:new    ;}\n\t.st2{fill:#757575;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{opacity:0.7;fill:url(#Ellipse_111_00000121981869151350729710000002353192458780641689_);enable-background:new    ;}\n\t.st5{fill:#D5D5D5;}\n\t.st6{fill:#B7B7B7;}\n\t.st7{fill:#5A5A5A;}\n\t.st8{fill:#444444;}\n\t.st9{fill:#464646;}\n\t.st10{fill:#D1D1D1;}\n\t.st11{fill:#868686;}\n\t.st12{fill:#525252;}\n\t.st13{fill:#B5B5B5;}\n\t.st14{fill:#989898;}\n\t.st15{fill:#838383;}\n\t.st16{fill:#ABABAB;}\n\t.st17{fill:#303030;}\n\t.st18{fill:#9B9B9B;}\n\t.st19{fill:#202020;}\n\t.st20{fill:#939393;}\n\t.st21{fill:#ACACAC;}\n\t.st22{fill:#3D3D3D;}\n\t.st23{fill:#8E8E8E;}\n\t.st24{fill:#595959;}\n\t.st25{fill:#D8D8D8;}\n\t.st26{fill:#404040;}\n\t.st27{fill:#474747;}\n\t.st28{fill:#848484;}\n\t.st29{fill:#A0A0A0;}\n\t.st30{fill:#8A8A8A;}\n\t.st31{fill:#B8B8B8;}\n\t.st32{fill:#4E4E4E;}\n\t.st33{fill:#969696;}\n\t.st34{fill:#D4D4D4;}\n\t.st35{fill:#A5A5A5;}\n\t.st36{fill:#6D6D6D;}\n\t.st37{fill:#DFDFDF;}\n\t.st38{fill:#434343;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_21003",
    transform: "translate(-359.384 -77)"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 285,
    height: 133,
    id: "Path_786_00000003080929973465144460000004052047037726820747_",
    xlinkHref: "17E645F626A236C.png",
    transform: "matrix(1 0 0 1 359.384 197)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    transform: "translate(7.48 -26.58)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_671_00000116950739037732054510000004215256738122940301_",
    gradientUnits: "userSpaceOnUse",
    x1: -461.2306,
    y1: 774.6119,
    x2: -461.2306,
    y2: 773.6119,
    gradientTransform: "matrix(242.767 0 0 -206.795 112462.0703 160312.0469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.855
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.631
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.439
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.282
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.157
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.071
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    style: {
      opacity: 0.8,
      fill: "url(#Path_671_00000116950739037732054510000004215256738122940301_)",
      enableBackground: "new"
    },
    d: " M611.9,333H369.1l47.8-206.8h145.3L611.9,333z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_465",
    className: "st2",
    d: "M416.1,114h146.7c1.4,0,2.5,1.1,2.5,2.5v3.9c0,1.4-1.1,2.5-2.5,2.5H416.1 c-1.4,0-2.5-1.1-2.5-2.5v-3.9C413.6,115.1,414.7,114,416.1,114z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_500-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_466",
    className: "st2",
    d: "M423.1,103.6h2.6c0.4,0,0.8,0.4,0.8,0.8v9.9c0,0.4-0.4,0.8-0.8,0.8h-2.6 c-0.4,0-0.8-0.4-0.8-0.8v-9.9C422.3,103.9,422.6,103.6,423.1,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_467",
    className: "st2",
    d: "M465.6,103.6h2.6c0.4,0,0.8,0.4,0.8,0.8v9.9c0,0.4-0.4,0.8-0.8,0.8h-2.6 c-0.4,0-0.8-0.4-0.8-0.8v-9.9C464.8,103.9,465.2,103.6,465.6,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_468",
    className: "st2",
    d: "M508.2,103.6h2.6c0.4,0,0.8,0.4,0.8,0.8v9.9c0,0.4-0.4,0.8-0.8,0.8h-2.6 c-0.4,0-0.8-0.4-0.8-0.8v-9.9C507.4,103.9,507.7,103.6,508.2,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_469",
    className: "st2",
    d: "M550.8,103.6h2.6c0.4,0,0.8,0.4,0.8,0.8v9.9c0,0.4-0.4,0.8-0.8,0.8h-2.6 c-0.4,0-0.8-0.4-0.8-0.8v-9.9C550,103.9,550.3,103.6,550.8,103.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_470",
    className: "st3",
    d: "M416.9,121.1h145.3c0.8,0,1.5,0.7,1.5,1.5v2.1c0,0.8-0.7,1.5-1.5,1.5H416.9 c-0.8,0-1.5-0.7-1.5-1.5v-2.1C415.4,121.8,416.1,121.1,416.9,121.1z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ellipse_111_00000105385623387955093270000014478713396856616630_",
    cx: -451.6628,
    cy: 748.0036,
    r: 1.972,
    gradientTransform: "matrix(63.1706 0 0 -14.4962 29020.8281 11174.5059)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.984
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.937
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.855
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.216
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_111",
    style: {
      opacity: 0.7,
      fill: "url(#Ellipse_111_00000105385623387955093270000014478713396856616630_)",
      enableBackground: "new"
    },
    cx: 490.8,
    cy: 335,
    rx: 132.2,
    ry: 31.7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    transform: "translate(456.066 126.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    className: "st5",
    d: "M62.7,63.3c1.3,1.8,2.9,4.1,2.9,4.1c-0.5,2-4,14.4-4,14.4l7.9,4.4c3.9-5.9,8.9-17,9.5-18.5 c0.7-1.5,0.6-3.3-0.3-4.7c-1.5-2.7-3.3-5.3-5.5-7.5L62.7,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    className: "st5",
    d: "M9.2,50c-3,1.7-5.8,3.6-8.3,5.9c-0.8,0.8-1.1,1.6-0.7,3.3c0.8,4,2.1,8,3.8,11.7 c0.4,0.8,1.9,7.3,1.9,7.3l7.2-0.6c0.2-4.1,0.3-16.1,0.3-16.1l3.6-1.4L9.2,50z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    className: "st6",
    d: "M71,62.4c1.8-1.1,3.4-2.3,5.1-3.6c-0.8-1.2-1.8-2.3-2.8-3.3l-10.5,7.8c0.6,0.9,1.4,2,2,2.8 C66.7,64.9,68.9,63.7,71,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    className: "st6",
    d: "M8.8,58.9c1.3,1.4,2.8,2.5,4.6,3.2c0-0.4,0-0.6,0-0.6l3.6-1.4L9.2,50c-1,0.6-2.1,1.3-3.1,2 C6.2,54.5,7.2,56.9,8.8,58.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    transform: "translate(23.559 3.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    transform: "translate(9.191 30.397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    x: 0,
    y: 0,
    className: "st5",
    width: 13.5,
    height: 18.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    className: "st6",
    d: "M0,3.4c4,3.2,9.8,2.9,13.5-0.6V0H0V3.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    transform: "translate(0 14.247)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_107",
    transform: "matrix(8.299956e-02 -0.9965 0.9965 8.299956e-02 19.7757 30.6395)",
    className: "st5",
    cx: 26.5,
    cy: 4.6,
    rx: 4.3,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    className: "st6",
    d: "M26.9,2.1c-1.4-0.3-2.7,0.6-3,2s0.6,2.7,2,3c1.4,0.3,2.7-0.6,3-2c0-0.2,0-0.3,0-0.5 C29.1,3.3,28.2,2.2,26.9,2.1z M26.9,6c-0.6,0-1-0.5-1-1s0.5-1,1-1c0.6,0,1,0.5,1,1c0,0,0,0,0,0C27.9,5.5,27.5,6,26.9,6 C26.9,6,26.9,6,26.9,6L26.9,6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_108",
    transform: "matrix(0.9965 -8.299953e-02 8.299953e-02 0.9965 -0.3653 0.3585)",
    className: "st5",
    cx: 4.1,
    cy: 4.6,
    rx: 3.8,
    ry: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    className: "st6",
    d: "M1.7,4.6C1.9,5.7,3,6.4,4.2,6.2S6,4.9,5.8,3.8c-0.2-1-1-1.7-2-1.7C2.5,2.2,1.6,3.3,1.7,4.6z  M2.7,5c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1c0,0.6-0.5,1-1,1C3.2,6,2.7,5.5,2.7,5L2.7,5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    className: "st5",
    d: "M15.9,33.6c4.9,0,11-3.3,11-14.4S29,0,15.2,0S3.8,13.6,3.8,19.7 C3.8,30.2,10.9,33.6,15.9,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    className: "st6",
    d: "M15.4,22.2c-0.9,0-1.7-0.3-2.3-0.9c0,0.1-0.1,0.2-0.1,0.4c0,0.9,1.1,1.7,2.4,1.7 s2.4-0.8,2.4-1.7c0-0.1,0-0.2-0.1-0.4C17.1,21.9,16.2,22.3,15.4,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    className: "st7",
    d: "M9.1,23.7c2.1,0.3,4.2,0.5,6.3,0.4c3.8-0.1,6.6-0.4,6.6-0.4s-1.4,3.5-6.4,3.5 S9.1,23.7,9.1,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    className: "st6",
    d: "M15.5,28.8c-0.8,0-1.7-0.1-2.5-0.2c0,0.1,0,0.1,0,0.2c0,0.8,1.1,1.5,2.4,1.5s2.4-0.7,2.4-1.5 c0,0,0-0.1,0-0.1C17,28.7,16.2,28.8,15.5,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    className: "st3",
    d: "M15.4,24.1c-1.6,0-2.9,0-3.9-0.1v1.7c2.6,1.4,5.8,1.4,8.4,0v-1.8 C18.7,24,17.2,24.1,15.4,24.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    transform: "translate(7.112 11.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    transform: "translate(9.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    className: "st8",
    d: "M1.6,0C1.1,0,0.5,0.1,0,0.2V2c0.9-0.2,1.9-0.3,2.9-0.3c1.3,0,2.7,0.2,3.9,0.7 C6,1,4,0,1.6,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    className: "st8",
    d: "M5.2,0c0.5,0,1.1,0.1,1.6,0.2V2C5.9,1.8,4.9,1.6,3.9,1.6C2.6,1.6,1.3,1.9,0,2.3 C0.8,1,2.8,0,5.2,0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    className: "st6",
    d: "M15.4,24.4c3.3-0.1,5.8-0.3,6.4-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0,0-2.7,0.3-6.6,0.4 c-2.1,0.1-4.2-0.1-6.3-0.4c0,0.1,0.1,0.2,0.2,0.3C11.3,24.4,13.3,24.5,15.4,24.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    transform: "translate(17.138 14.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    className: "st3",
    d: "M0,2.6c0.7,1,1.8,1.6,3.1,1.6c1.7,0,2.9-0.6,3.3-2.2C5.6,0.8,4.5,0.1,3.2,0 C1.5,0,0.6,1,0,2.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_109",
    className: "st9",
    cx: 3,
    cy: 2.3,
    rx: 1.3,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    className: "st6",
    d: "M6.1,1.7C5.8,3.3,4.6,3.9,2.9,3.9C2,4,1.2,3.8,0.6,3.2C1.3,4,2.3,4.5,3.4,4.4 c1.7-0.2,2.9-0.8,3-2.5C6.1,1.6,6,1.5,6.1,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    className: "st8",
    d: "M2.9,1c1.2,0,2.4,0.3,3.4,0.9C5.7,0.7,4.5,0,3.2,0C1.6-0.1,0.2,1,0,2.6 C0.7,1.7,1.8,1.1,2.9,1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    transform: "translate(6.975 14.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    className: "st3",
    d: "M6.3,2.6c-0.7,1-1.8,1.6-3.1,1.6C1.6,4.1,0.4,3.5,0,1.9C0.7,0.8,1.9,0.1,3.1,0 C4.9,0,5.8,1,6.3,2.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_110",
    className: "st9",
    cx: 3.4,
    cy: 2.3,
    rx: 1.3,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    className: "st6",
    d: "M0.2,1.7c0.4,1.6,1.6,2.2,3.3,2.2c0.8,0,1.7-0.2,2.3-0.8C5.1,4,4.1,4.4,3,4.4 C1.2,4.2-0.1,3.5,0,1.9C0.2,1.6,0.4,1.5,0.2,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    className: "st8",
    d: "M3.4,1C2.2,1,1,1.3,0,1.9C0.6,0.7,1.8,0,3.1,0c1.6-0.1,3,1,3.2,2.6C5.6,1.7,4.6,1.1,3.4,1z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    className: "st10",
    d: "M66.2,46.1c-5.8-4.6-12.7-7.6-20-8.7v0c-0.6,2.1-2,3.8-4,4.7l-1,3l-1.6,5.1l-1.8-5l-1-2.7 c0,0-4.1-2-4.1-4.8c-7.2,1.2-10.8,3.9-14.3,5.8c-4.4,2.4-11,6.8-11,6.8c0.8,2.6,1.9,5,3.3,7.4c1.3,2.1,2.9,3.9,4.7,5.6l4.5-2.2 c0,0-0.2,6.3-0.2,10.9s-0.5,17.7-0.5,17.7h42.5c-0.1-2.6-0.8-14.1-1.3-18.6S59.3,62,59.3,62l3.7,3.6c0,0,4.2-3.8,5.8-4.9 s6.7-4,6.7-4S70,49.1,66.2,46.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    transform: "translate(19.809 37.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    className: "st11",
    d: "M20.5,27.7c6.3,0,14.9,1.8,16,10.6s2.1,19.1,2.1,19.1H4c0,0,0.5-13.8,1.2-18.8 S9.6,27.7,20.5,27.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    transform: "translate(0 26.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    className: "st12",
    d: "M0,0l6.4,5L5,7.5L0,4.3V0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    className: "st12",
    d: "M5.6,5.3l2.1,1.5L6.8,8l-2-1.5L5.6,5.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    transform: "translate(6.28 0.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    className: "st12",
    d: "M0,1.3L4,0l4.7,26.2l-3.4,1L0,1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    className: "st12",
    d: "M6.1,26.3l0.4,2.4l1.7-0.6l-0.7-2.3L6.1,26.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    transform: "translate(24.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    className: "st12",
    d: "M0,26.4l3.4,0.5L7,1L3.8,0L0,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    className: "st12",
    d: "M0.9,26l1.7,0.2l-0.5,2.7l-1.6-0.3L0.9,26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    transform: "translate(33.144 26.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    className: "st12",
    d: "M0.8,4l1.9,2.7l4.4-3L6.6,0L0.8,4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    className: "st12",
    d: "M2.2,4.4l0.8,1.2L1,7L0,5.6L2.2,4.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    transform: "translate(31.848 42.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    className: "st13",
    d: "M0,4.9l5-4.4l1,2.7L0.4,5.6L0,4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    className: "st13",
    d: "M10.4,0l5,4.5l-0.2,0.8L9.5,3L10.4,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    className: "st14",
    d: "M39.1,12c5.3,0,10.9,5,11.3,7.1l1.9-0.2c1-9.2-1.3-17.7-12.7-17.7c-12,0-15.3,9.3-14,17.7 l1.9,1.2C28.8,15.4,33.7,11.9,39.1,12z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    transform: "translate(25.313 4.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    className: "st15",
    d: "M27.2,10.8c0-1.5-0.1-3-0.3-4.5c-1.5,2.1-2.6,3.5-2.4,4.5C24.5,11.5,26,11.2,27.2,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    className: "st15",
    d: "M24.8,1c-2,3.3-3.4,6.4-2.7,7.2s3.3-0.5,4.7-2C26.5,4.3,25.8,2.6,24.8,1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    className: "st15",
    d: "M0,9.7c1.6,0.9,2.7,1,3.2,0.6c0.6-0.6-0.1-3.2-0.8-4.4C4.3,8.1,5.5,8,6.1,7.5s-0.2-2.7-1.1-5 C4.6,1.6,4.2,0.7,3.8,0C1.4,2.6,0,6.1,0,9.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    className: "st16",
    d: "M39.6,1.2c-4.8,0-8.2,1.5-10.5,3.8c1.9,3.8,2.9,5.8,4.2,5.3c1.4-0.5,1.5-2,1.3-4.5 c0.7,3.5,1.7,3.8,2.6,3.8s2.2-1.8,2.2-4.5c0.2,3.1,0.7,5,1.8,5.2s2.6-0.7,3.9-3.1c-0.9,2.7-1.1,3.7-0.3,4.2 c0.7,0.5,3.2-1.3,5.5-5.5C48.3,3,44.9,1.2,39.6,1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    className: "st15",
    d: "M38.6,11.1c-5.4-0.1-10.1,3.5-11.5,8.6l0.5,0.3c1.2-4.6,6.2-8.1,11.6-8c5.3,0,10.9,5,11.3,7.1 l0.6,0C50.3,16,45.4,11,38.6,11.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    transform: "translate(16.973 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    transform: "translate(33.266 15.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_463",
    className: "st17",
    d: "M7.7,5.1L10,5.2c0.6,0,1,0.5,1,1l0,0.9c0,0.6-0.5,1-1,1L7.6,8l0,0L7.7,5.1L7.7,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    className: "st18",
    d: "M2.4,0.9c5.1,0.3,6.1,2.6,6.1,5.9c-0.1,3.4-1.5,6-6.7,5.5L2.4,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    className: "st17",
    d: "M1.3,0l1.1,0c0.7,0,1.3,0.6,1.3,1.3c0,0,0,0,0,0L3.4,12.1c0,0.7-0.6,1.3-1.3,1.2 c0,0,0,0,0,0l-0.8,0C0.5,13.3,0,12.7,0,12L0,1.3C0,0.6,0.6,0,1.3,0C1.3,0,1.3,0,1.3,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    transform: "translate(0 15.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_464",
    className: "st17",
    d: "M0.8,6.6l2.6-0.3l0,0L3.7,9l0,0L1.1,9.3C0.7,9.4,0.3,9,0.2,8.6c0,0,0,0,0,0l-0.1-1 C0,7.1,0.4,6.7,0.8,6.6C0.8,6.6,0.8,6.6,0.8,6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    className: "st18",
    d: "M8,1.1C3,2,2.2,4.4,2.8,7.7c0.5,3.4,2.3,5.7,7.4,4.6L8,1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    className: "st17",
    d: "M9,0L7.9,0.2C7.2,0.3,6.7,0.9,6.8,1.6c0,0,0,0,0,0l1.7,10.6c0.1,0.7,0.8,1.2,1.5,1.1 c0,0,0,0,0,0l0.8-0.1c0.7-0.1,1.1-0.8,1-1.4L10.4,1.1C10.3,0.4,9.7-0.1,9,0C9,0,9,0,9,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    className: "st19",
    d: "M3.1,28.5c-0.2,0-0.4-0.2-0.5-0.4c-0.1-0.3-1.7-6.7-2.1-10.3c-0.4-3.7,0.7-5.6,3.2-8.1 C3.8,9.6,13.4,0,22.4,0h0.1c6.8,0,12.3,4.7,15.3,7.2c0.4,0.3,0.7,0.6,1,0.8c2.5,2,5.2,5.5,5,9.2c-0.2,3.3-1.3,9.6-1.3,9.9 c-0.1,0.3-0.3,0.5-0.6,0.4c-0.3-0.1-0.4-0.3-0.4-0.6c0-0.1,1.1-6.5,1.3-9.8s-2.3-6.5-4.6-8.3c-0.3-0.2-0.6-0.5-1-0.9 C34.2,5.5,28.9,1,22.4,1h-0.1c-3.1,0-6.8,1.3-10.8,3.8c-2.6,1.6-5,3.5-7.1,5.6c-2.3,2.3-3.3,3.9-2.9,7.2c0.4,3.5,2,10.1,2,10.2 c0.1,0.3-0.1,0.6-0.4,0.6C3.2,28.5,3.1,28.5,3.1,28.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    d: "M27.7,38.7c0,0,3.3,16,3.7,15.9s16.3,0,16.3,0L50.6,38l3.6,1.1c0,0-1.6,12.2-1.6,12.9 c0.4,1.5,0.9,3.1,1.5,4.5c0,0,2.7,8.7,3.4,11.8s2.7,13.4,2.9,15.1s1,9.4,1,9.4H21.8c0,0,0.6-12.4,1.1-16.8s2.6-15.7,3-18 s1.1-5.3,1.1-5.3s-3-12.5-3-12.6S27.7,38.7,27.7,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    className: "st20",
    d: "M29.7,88.3c7.9,0,12.9,3.9,19.7,5.8s14.8,3.1,15.4,6.4c0.6,3.3,0.4,5.3-2.3,5.3H20.5 c-2,0-4.8-0.8-4.7-4.7S18.5,88.3,29.7,88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    className: "st11",
    d: "M67.1,80.7c3.4,1.6,4.5,3,4.7,3.3s0.3,0.6,0,1.2s-6.2,9.9-7.2,11.3S63,98.9,61.2,98 s-3.4-1.9-3.4-1.9l-2.5,0.1c-0.9,2.1-2.7,4.4-4.3,4c-1.4-0.4-1.1-1.3-0.5-2.9s0.7-2,0.7-2c-2,2.5-3.6,4.8-5.5,4.1 c-1.6-0.6-0.6-2.1-0.6-2.1c-1.5,1.8-2.5,2.1-3.4,1.7c-0.7-0.4-1-1.3-0.6-2c0.1-0.1,0.2-0.2,0.3-0.3c-0.6,0.6-1.6,0.7-2.2,0.1 c-0.5-0.5-0.7-1.3,0.2-3.3s1.1-3,1.6-3.7c1.1-1.3,2.4-2.4,3.7-3.5c0.7-0.7,1.7-1,2.7-0.9c1.6,0.2,3.2,0.5,4.7,0.9 c1.4,0.3,5.3,1.1,5.3,1.1c0.6-1,1.1-2,1.5-3.1c0.7-1.7,1.7-4.3,1.9-4.8s0.4-0.7,1.4-0.5C63.9,79.3,65.6,79.9,67.1,80.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    className: "st21",
    d: "M67.3,82.4c0.2-0.3,0.1-1.1-0.8-1.4c-1.7-0.6-3.4-1.2-5.2-1.6c-0.2,0.1-0.4,0.2-0.6,0.3 c-0.3,0.8-1.2,3-1.8,4.5c-0.4,1.1-0.9,2.1-1.5,3.1c0,0-4-0.8-5.3-1.1c-1.6-0.4-3.1-0.7-4.7-0.9c-1-0.2-2,0.2-2.7,0.9 c-1.3,1.1-2.6,2.3-3.7,3.5c-0.5,0.8-0.7,1.7-1.6,3.7c-0.3,0.6-0.5,1.1-0.6,1.8c0.7,0,1.3-0.3,1.9-1.5c0.9-1.6,3.6-5.5,4.8-5.9 c0.7-0.3,1.5-0.4,2.3-0.3c-1.1,0.7-2,1.6-2.9,2.6c-1,1.5-1.9,3.1-2.6,4.7c-0.3,0.5-0.5,1.1-0.8,1.6c1.6,0.2,2.5-0.7,3.2-2.1 c0.6-1.4,1.5-2.7,2.7-3.7c1.1-0.8,2.1-1.6,3.7-1.3c-1.3,0.8-2.4,1.8-3.4,3c-0.7,1.1-1.2,2.2-1.7,3.4c-0.5,1.1-0.6,1.4-0.6,1.4 c1.3,0,2.3-1.3,3-2.6c0.6-1.1,1.4-2,2.4-2.6c1-0.5,2.1-0.6,3.2-0.5c-1.2,1-2.2,2.4-2.7,3.9c0,0,0,0.1,0,0.2 c-0.3,1-0.7,2.1-0.7,2.1c1.5,0.2,2.4-1.4,3.1-2.7c0.7-1.3,2-2.2,3.5-2.2c1.4,0,2.6,0.2,3.6-1.2s4.2-5.4,5.2-6.8 S67.1,82.7,67.3,82.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    className: "st2",
    d: "M64,104.5c-3.9-0.2-7.8-0.5-11.8-0.7c-6.4-0.4-12.8-0.7-19-2.4c-5.5-1.5-10.8-3.8-16.4-4.7 c-0.6,1.5-1,3.1-1,4.8c-0.1,3.9,2.7,4.7,4.7,4.7h41.9c1.5,0,2.2-0.6,2.5-1.7C64.6,104.5,64.3,104.5,64,104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    className: "st22",
    d: "M6.5,81.1c0,0-3.2-1.9-3.5-2.1s-1.7,0.4-2,0.4s-0.4,0.7-0.5,1.3s0,1.8,0,2.2 c-0.1,0.5,0.2,1,0.7,1.2c0.6,0.3,3.3,1.6,3.3,1.6L6.5,81.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    transform: "translate(2.616 75.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    className: "st23",
    d: "M6.8,0.3c1.7-0.3,3.5-0.3,5.2-0.2c0.5,0,0.6,0.3,0.7,1s0.5,4.1,0.5,4.1 c1.2,0.5,2.3,1.2,3.2,2.1c0.8,0.7,1.3,1.6,1.3,2.7c-0.1,1.2-0.3,3.1-0.3,3.1s-0.8,2.5-1,3.4c-0.3,1-1.1,1.8-2.1,2.1 c-1.5,0.4-3,0.7-4.5,1c-0.8,0-2.9,0-3.2-1.1c-1-0.3-2.1-0.3-2.6-1.6c-1.8-0.4-2-1-2-1.8C0.2,14.6,0,14,0,13 C0.1,12,0.5,10.9,1,10c0.6-1.3,2.3-4.6,2.3-4.6s-0.7-1.9-1-2.5s0.2-1.3,0.6-1.5C4.1,0.8,5.4,0.5,6.8,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    className: "st24",
    d: "M2.4,3c3.1-1.9,6.7-2.6,10.2-2v0c-0.1-0.6-0.2-1-0.7-1C10.2-0.1,8.5,0,6.8,0.3 C5.4,0.4,4.1,0.8,2.9,1.4C2.6,1.6,2,2.3,2.3,2.9C2.4,2.9,2.4,3,2.4,3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    transform: "translate(12.127 10.486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    className: "st22",
    d: "M2.1,0c0,0,1.7,0.6,1.9,0.8c0.3,0.1,0.5,0.4,0.5,0.6c0,0.3-0.7,4.2-0.7,4.2 C3.1,5.9,2.4,6.2,1.6,6.4C1.1,6.2,0.5,6,0,5.7c0,0,0.5-4.1,0.5-4.5c0-0.4,0.3-0.7,0.6-0.8C1.6,0.3,2.1,0,2.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    className: "st21",
    d: "M3.2,1.5l19.1,10.3c-6.6,0-17-4.5-20.1-5.9L3.2,1.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    transform: "translate(5.115 4.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    className: "st25",
    d: "M8,2.8L6.7,2.1C6,2.8,4.7,4,4,4.6C4.5,4.8,5,5,5.5,5.2L8,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    className: "st25",
    d: "M0,3.1c0.8,0.3,1.7,0.7,2.6,1.1l2.6-2.8L2.8,0L0,3.1z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_21004",
    transform: "translate(393.926 132.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    className: "st26",
    d: "M35.2,107.5c-3.3,11-4.5,18.2-5.8,22.8c-0.5,1.9-1.3,2.8-0.1,8.9s3,14.4,3.3,18.4 c-2.2,2.5-5,2.4-7.1,2.5c-1.9,0-3.7-0.6-5.2-1.6c-0.7-4.3-3-15.5-3.9-21s-0.8-7-0.4-12.3c0.4-4.4,1.1-8.8,2.2-13.1 c0.7-3.4,1.8-9.2,1.8-9.2L35.2,107.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    className: "st27",
    d: "M33.9,106.2c0,0,2,15.6,2.4,20.2s1.6,6.6,2.1,10.2s0.7,25.9,0.7,25.9c1.4,1.7,6.9,1.3,8.6,1 s4.2-1.2,4.8-1.9c-0.1-5.8,0.1-16.7,0.3-23.6s-0.9-13.6-1-18.8s0-14.9,0-14.9L33.9,106.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    transform: "translate(0 51.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    className: "st28",
    d: "M6.6,11.8L0.9,0L0,0.2l5.5,11.9L6.6,11.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    transform: "translate(4.01 10.625)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_343",
    transform: "matrix(0.9331 -0.3597 0.3597 0.9331 -0.5392 0.9537)",
    className: "st24",
    cx: 2.3,
    cy: 1.9,
    rx: 2,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_344",
    transform: "matrix(0.9331 -0.3597 0.3597 0.9331 -5.2452 4.4454)",
    className: "st24",
    cx: 9.3,
    cy: 16.3,
    rx: 1.6,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    className: "st24",
    d: "M4.1,1.2L0.5,2.6l1.2,1.6c0,0,2.6,6.9,3.7,8.9c0.7,1.3,1.6,2.6,2.6,3.7l2.9-1.1 c-0.4-1.5-0.9-3-1.7-4.4C8,9.5,4.5,3,4.5,3L4.1,1.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    className: "st5",
    d: "M16.9,69.5c-1.1-0.2-4.1-2.3-5.6-3.2s-2.5-1.8-3.6-1.8s-3.6,2.1-4.2,2.7s0.2,2.1,0.7,2 c-0.4,0.6-0.5,0.8-0.4,1.2s0.2,1.1,0.9,0.9c-0.1,0.7,0.8,1.6,1.3,1.4c-0.6,0.8,0,1.4,0.6,1.7s0.2,0.1,1.5,0.8s0.9-0.8,0.9-0.8 c1.6,0.3,3.3,0.5,5,0.4c1.4-0.1,2.9-0.2,4.3-0.1L16.9,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    className: "st5",
    d: "M16.2,90.7c-3.2,6-3.6,6.9-3.9,7.4c-0.3,0.4-0.5,0.9-0.4,1.5c0,0.6,0.1,2.1,0.1,2.6 s0.7,0.7,0.8,1.2c0.3,0.6,0.5,1.3,0.7,2c0.1,0.6,0.2,0.9,0.8,0.7s1-0.9,1-2.3s-0.2-3.5-0.2-4s1.2-1.2,1.2-1.2 c-0.6,2.2-0.8,4.5,0.3,4.8c0.6,0.2,0.6-0.2,0.9-1.3s1.1-2.5,1.3-3.1s0.7-5.3,0.7-5.3L16.2,90.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    className: "st29",
    d: "M22,60.4c-0.7,8.6-0.7,10-1.1,14.6S17,87.3,15.3,91.1c1.9,1.2,3.5,2.8,4.7,4.6l2.1-12.2 l1.2-23.1L22,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    className: "st30",
    d: "M41,30.2c3.9,1.8,11.9,7.6,13.9,11.7S53.2,69,53.2,77.7c0,8.7,3.2,22.6,3.5,30 c-4.6,1.6-14.6,2.3-21.3,2.2c-5.9-0.1-11.7-0.6-17.6-1.5c1.1-8.5,3.4-21.7,3.8-30.8s0.9-15.5,0.9-15.5c-1.9-1.6-3.7-3-3.7-5 s2.7-5.4,3.6-9.1s1.4-9.7,3-11.6s5.9-5.4,8-5.9C35.9,30.3,38.4,30.2,41,30.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    className: "st29",
    d: "M51,39.6c-4.8-0.3-6,8.1-7.4,13.2s-3.9,12.7-3.9,12.7c-3.8,1.2-7.8,2-11.8,2.3 c-7.3,0.7-9.7,0.8-11.2,0.9s-1.6,4-1.2,5.6s0.8,4.1,2.3,4.2s13.7,0.2,18.1-0.3s8.8-0.7,10-1.9s5.7-8.3,7.4-13.7S60.2,40.1,51,39.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    className: "st29",
    d: "M40.3,27.5c1.1,1.2,2.2,2.5,3.1,3.9c-3,3.2-9.3,9.4-9.3,9.4c-0.9-1.8-2-3.6-3.3-5.2 c-1.2,1-2.2,2.2-3.2,3.4c0.1-2.7,0.9-5.3,2.1-7.7c1-1.5,3-4.4,5.7-4.7C37.1,26.5,38.8,26.8,40.3,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    className: "st29",
    d: "M41,47.2c-1.9,0.1-6.3-0.3-7.9-0.5c-0.2,0-0.3,0.1-0.3,0.3c0,0,0,0,0,0l0,0.3 c0,0.2,0.1,0.3,0.2,0.3c2.6,0.4,5.3,0.6,8,0.7c0.2,0,0.3-0.1,0.3-0.3l0-0.5C41.4,47.4,41.2,47.2,41,47.2C41,47.2,41,47.2,41,47.2z "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    transform: "translate(23.174 23.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    className: "st5",
    d: "M7.1,12.9L6.2,9.5C4.1,9.7,1.9,9.3,0,8.3C-0.5,7.8,17,0,17,0l0.4,4.6c-1.4,1.6-2.8,3-4.4,4.4 C11.1,10.4,7.1,12.9,7.1,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    className: "st6",
    d: "M10.2,3.1c0.2,0.6,0.3,1.2,0.3,1.8c0,2.3-1.6,4.4-4.1,5.5L6.2,9.5C4.1,9.7,1.9,9.2,0,8.3 C-0.3,8,5.3,5.3,10.2,3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    transform: "translate(18.797 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    className: "st5",
    d: "M5,32.1c-2.5-0.3-4.5-6.7-4.5-11.3s-0.2-19,11.8-19s13.1,9.6,12.3,14.8 c-0.5,3.2-3.2,7.4-5.7,10.3C15.4,30.7,10.2,32.7,5,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    className: "st3",
    d: "M7.1,17.2c0.3,1,1.2,1.7,2.2,1.6c1.1,0.2,2.1-0.5,2.4-1.5c-0.5-0.7-1.3-1-2.2-1 C8.7,16.3,7.8,16.7,7.1,17.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_345",
    className: "st9",
    cx: 10.3,
    cy: 17.4,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    className: "st3",
    d: "M0.9,17.2c0.2,0.8,0.9,1.5,1.8,1.4c0.9,0.1,1.8-0.6,1.9-1.5c-0.5-0.5-1.2-0.8-1.9-0.8 C2,16.3,1.3,16.7,0.9,17.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_346",
    className: "st9",
    cx: 3.3,
    cy: 17.2,
    rx: 0.9,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    className: "st31",
    d: "M10.3,24.8c-0.4,0.1-0.9,0.1-1.3,0.1c-1.3,0-3.1,0-3.9,0c-0.6,0-1.5,0-2.1-0.1 c-0.3,0-0.6-0.1-0.9-0.2C2.7,26.3,2.8,28,5.2,28s3.2-0.3,4-1.2C9.6,26.2,10,25.5,10.3,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    className: "st3",
    d: "M8.7,25.6l-5.3-0.1c0,0-0.1,0.5,0.9,0.7c0.8,0.1,1.7,0.2,2.6,0.1C7.5,26.2,8.2,25.9,8.7,25.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    className: "st6",
    d: "M6.7,22.4c-1.1,0-2.3-0.1-3.4-0.3c0,0.8,0.7,1.4,1.5,1.4C5.6,23.7,6.7,22.4,6.7,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    className: "st32",
    d: "M7,17.2c0.1-1.1,1.3-1.5,2.3-1.4c1.1,0.1,1.6,0.8,2.5,0.8c0.5,0,0.9-0.1,1.3-0.2 c-0.1,0.3-0.3,0.6-0.6,0.8c-0.2,0.2-0.6,0.3-0.9,0.2c-0.7-0.5-1.6-0.7-2.4-0.7C8.5,16.7,7.7,16.9,7,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    className: "st32",
    d: "M4.6,17.2C4.5,16.5,3.8,16,3.1,16c-0.7,0-1.7,0.5-2.3,0.5S0,16.4,0,16.4 c0,0.2,0.1,0.5,0.3,0.6c0.2,0.1,0.5,0.2,0.7,0.2c0.5-0.3,1.1-0.4,1.7-0.4C3.4,16.7,4,16.8,4.6,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    className: "st32",
    d: "M13.5,15.1c-1-0.8-2.3-1.2-3.5-1.3c-0.9,0-1.9,0-2.8,0.1c-0.6,0.1-0.6-0.7,0.2-0.9 c1.3-0.2,2.6-0.2,3.9,0.2C12.1,13.6,13,14.2,13.5,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    className: "st32",
    d: "M4.2,13.1c-0.7-0.1-2.9,0.1-3.7,1c1.2-0.2,2.4-0.3,3.6-0.3C4.8,13.9,5.1,13.3,4.2,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    className: "st6",
    d: "M16.8,23.6c0.7,0.8,1.8,1.2,2.8,0.9c1.3-0.5,2.4-1.4,2.9-2.7c0.7-1.2-4.4-1.5-4.4-1.5 L16.8,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    className: "st32",
    d: "M23.4,25.7c-0.4,1-0.9,1.8-1.6,2.6c-0.6,0.6-1.2,1.3-1.2,1.3L20.6,24l0.8-1.7L23.4,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    className: "st5",
    d: "M16.8,23.6c1.6,1,4.6-0.5,5.5-3.3c0.9-2.8-1.3-5.5-3.5-3.6L16.8,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    className: "st6",
    d: "M18.9,19.2l-0.8,2.9c0.9,0.3,1.9-0.1,2.4-0.9C21.4,19.7,18.9,19.2,18.9,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    className: "st33",
    d: "M23.1,26.2c-2-4.3-5.9-11.2-10.6-13.7c-4-2.2-9.4-1.3-11.2-0.7C-0.9,5.7,5.5-0.5,13.6,0 c7.7,0.5,13.9,6.5,13.7,16.1C27.2,23.8,23.1,26.2,23.1,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    className: "st16",
    d: "M13.6,0c3.9,0.2,7.5,2,10,4.9c-1.3,3.7-5.7,8.6-7.8,6.9c-0.9-0.7-0.9-2-0.4-3.5 c-1.4,1.1-2.7,1.7-3.6,0.9c-0.6-0.5-0.8-1.2-0.7-2C9.8,8.3,8.6,8.8,7.7,8.1C7.1,7.5,6.8,6.6,7.1,5.8C5.8,7,4.4,7.5,3.5,6.8 C2.8,6.2,2.7,5.2,3,4.1C5.7,1.2,9.7-0.3,13.6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    className: "st15",
    d: "M25.9,8.5c1,2.4,1.5,5,1.4,7.7c0,1.2-0.2,2.4-0.4,3.5c-1.5,1.3-3,2-4,1.2 c-0.8-0.6-0.9-1.8-0.5-3.1c-0.6,0.2-1.2,0.1-1.7-0.2c-0.6-0.6-0.9-1.4-0.7-2.2C22.2,14.5,24.9,11.2,25.9,8.5z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_21005",
    transform: "translate(536.84 135.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77491",
    className: "st34",
    d: "M75.9,29.1c-2.2,2.7-1.3,7.8-1.6,11.2c-0.4,5-0.4,10-0.6,15c-0.3,6.7-0.3,13.4-0.3,20 c0,5.6-0.4,11.1-0.6,16.6c0,0.9-0.1,2.1,0.8,2.6c1,0.5,1.5-0.2,1.9-1.1c0.4-1.6,0.5-3.3,0.4-4.9c0-3.4,0.2-6.9,0.4-10.3 c0.4-8.9-0.5-17.8-0.5-26.7c0-5.1-0.1-10.1,0.1-15.2c0.1-1.7,0.2-3.4,0.4-5C76.3,30.7,76.7,28.5,75.9,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77492",
    className: "st34",
    d: "M70.6,52.1c-0.1,6-0.1,12.1-0.1,18.1c0,5.6-0.3,11.1-0.4,16.6c0,0.9-0.1,2.1,0.6,2.6 c0.7,0.5,1.1-0.2,1.3-1.1c0.3-1.6,0.4-3.3,0.3-4.9c0-3.4,0.2-6.9,0.3-10.3c0.2-7.8-0.2-15.4-0.3-23.1 C71.6,50.6,71.1,51.3,70.6,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77493",
    className: "st34",
    d: "M79.8,38.7c-0.4,6.8-0.7,13.6-0.9,20.3c-0.2,6.3-0.8,12.5-1.2,18.7 c-0.1,1.1-0.1,2.4,0.5,2.9c0.7,0.6,1.1-0.2,1.4-1.2c0.3-1.8,0.5-3.7,0.5-5.5c0.2-3.9,0.5-7.7,0.7-11.6c0.6-8.7,0.5-17.4,0.7-26 C80.9,37.1,80.3,37.9,79.8,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77494",
    className: "st6",
    d: "M10.2,66l2.9-4.1l-6.9-5.2c-1.7,2.2-3.3,4.4-4.6,6.8C4.4,64.5,7.3,65.3,10.2,66z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20984",
    transform: "translate(55.304 22.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77495",
    className: "st5",
    d: "M6,27.3l5.7,4.6c0,0,4.6-7.6,6-10.2s4.4-9,4.4-9c-2.2-1.8-2.3-2.7-2.3-4.6 C20,6.4,19.7,4.7,19,3.2c-0.2-0.4,0.4-0.7,1.5-0.2c0.9,0.3,1.6,1,1.8,2c0.2,0.5,0.4,1,0.7,1.5c0.9-0.7,1.6-1.6,2.1-2.7 c1.6,0.4,6.8,3.4,6.8,3.4c-0.7,2.7-4,5.2-4.8,6.6s-3.2,12-5.5,17.1c-1.8,3.8-3.8,7.5-6.1,11c-0.5,0.9-1.5,1.5-3.7,0.5 c-4.1-2.2-8-4.7-11.8-7.4L6,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77496",
    className: "st6",
    d: "M25,3.8c-1.6,4-2.3,3.7-1.1,6c2.1,4.1,6.7-0.1,7.6-1.8L25,3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77497",
    className: "st5",
    d: "M27.9,3.3c0.7-0.8,0.7-2,0.1-2.9c-0.4-0.6-0.9-0.5-1.6-0.2s-3.1,1.7-3.7,2s-1,2,1.6,1.5 C25.5,3.5,26.7,3.3,27.9,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77498",
    className: "st6",
    d: "M25.3,2.4c-1,0.3-2,0.6-3,0.9c0.2,0.4,0.7,0.7,2,0.4c1.2-0.3,2.4-0.4,3.7-0.4 c0.4-0.5,0.6-1.2,0.5-1.8C27.4,1.8,26.4,2.1,25.3,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77499",
    className: "st5",
    d: "M32.6,6.6c-0.1-1.2-5.2-0.5-5.7-0.5s-1.3,1.6,0.8,1.8S32.8,8.8,32.6,6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77500",
    className: "st5",
    d: "M31.8,6.5c0.5-0.8,1-2.1-0.8-2.1s-4.8,0.1-5.2,0.1s-1.1,1.3,1,1.6S31.5,7,31.8,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77501",
    className: "st5",
    d: "M30.6,4.8c0.8-0.9,0.8-2.1-0.9-2.1c-1.6,0.1-3.1,0.3-4.6,0.5c-0.7,0.1-1.5,1.6,1,1.8 S30.2,5.3,30.6,4.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_77502",
    className: "st35",
    d: "M78.3,29c0.9,2.3,2.8,3.8,3.3,6.2c0.5,2.6,0,5.7,0,8.3c0,6.4-0.4,12.9-0.9,19.3 c-0.3,4.5,0,9-0.5,13.5c-0.2,1.5-0.2,3-0.2,4.5c0,0.6-0.3,1.6,0,2.1c0.4,0.5,2,0.6,2.5,0.4c1.1-0.5,0.8-2.7,0.8-3.7 c0-3.1-0.1-6.3-0.1-9.4c0-2.5-0.1-5-0.1-7.5c0-2.7,0.5-5.4,0.5-8.1c0-3.9-0.2-7.8-0.2-11.8c0-1.8-0.2-3.7-0.3-5.5 c-0.1-1.6,0.1-3.5-0.7-4.9c-0.7-1.1-1.5-2-2.4-2.9c-0.2-0.2-0.5-0.7-0.8-0.8c-0.4-0.2-0.7,0-1.2-0.2C78.1,28.4,77.7,29,78.3,29z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20985",
    transform: "translate(55.304 49.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77503",
    className: "st6",
    d: "M8.7,2.2L6,0L0,7.8c0.8,0.6,2.7,1.8,4.7,3.1L8.7,2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20986",
    transform: "translate(21.476 27.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77504",
    className: "st5",
    d: "M6.9,0L4.5,10.5l6.6,6.3l7.3-2l2.7-9L6.9,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77505",
    className: "st5",
    d: "M28.5,12.3c0-2-6.4-2.9-14.3-3.6C6.7,8,0,8.9,0,12.3c0,2,6.4,3.6,14.3,3.6 S28.5,14.3,28.5,12.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_77506",
    className: "st3",
    d: "M53.3,40.7c-3.3-2.8-7.3-3.8-10.8-4.2c-1.3,3.3-4.5,5.4-8,5.2c-4,0-7.3-2.4-8.2-5.7 c-2,0.4-3.9,1-5.7,1.8c-3.2,1.4-6.1,3.4-8.5,6c-2,2.3-8.7,12.4-8.7,12.4l9.8,7.9l3.8-5.4l0.4,31.2l33.8,0.5l0.2-32.8L57,61 l5.8-10.9C62.8,50.1,57.6,44.4,53.3,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77507",
    className: "st6",
    d: "M27.6,30.9c2.1,4.3,5.8,7.5,11.2,7.5c0.8,0,1.6-0.1,2.4-0.4l1.4-4.6l-14.2-5.8L27.6,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77508",
    className: "st5",
    d: "M48.5,15.5c0,7.5-0.1,20.9-8.9,20.8c-8.7-0.1-12.7-8.1-13.6-15.9 c-0.9-7.8,1.1-17.4,11.5-17.4S48.5,12,48.5,15.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20987",
    transform: "translate(16.988 36.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77509",
    className: "st36",
    d: "M6,16.3h24.8c0,0,2.8,16.3,4,18.9v26.8H0.1L0,35.4C1.5,32,6,16.3,6,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77510",
    className: "st36",
    d: "M1.8,1.7L5.9,0l5.4,17.7L6,16.3L1.8,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77511",
    className: "st36",
    d: "M26.8,17.5L27.2,0l4,1l-0.4,15.3L26.8,17.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_77512",
    className: "st5",
    d: "M28.7,22.7c0.2,2-0.9,3.8-2.6,4c-1.2,0.1-2.9-1.4-3.3-3.4c-0.4-1.7,0.6-3.5,2.4-4 c0.1,0,0.1,0,0.2,0C27,19.1,28.4,20.7,28.7,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77513",
    className: "st6",
    d: "M24.9,21c0.8,0.4,1.5,1.1,2,1.9c-0.7,0.2-1,0.9-0.8,1.6c0.1,0.2,0.2,0.4,0.3,0.5 c-0.6,0.7-1.8-0.8-2-1.9C24.4,22.4,24.5,21.6,24.9,21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77514",
    className: "st7",
    d: "M33.5,27.9c1.8,0.3,3.6,0.4,5.3,0.3c3.3-0.1,5.6-0.3,5.6-0.3s-1.2,3-5.5,3 S33.5,27.9,33.5,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77515",
    className: "st6",
    d: "M39.8,32.4c-0.6,0-1.2,0-1.9-0.1c0,0,0,0.1,0,0.1c0,0.6,0.8,1.1,1.8,1.1s1.8-0.5,1.8-1.1 c0,0,0-0.1,0-0.1C40.9,32.3,40.3,32.4,39.8,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77516",
    className: "st3",
    d: "M39.1,28.2c-1.3,0-2.5,0-3.3-0.1v1.4c2.2,1.2,4.9,1.2,7.1,0v-1.5 C41.9,28.1,40.6,28.2,39.1,28.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20990",
    transform: "translate(31.694 15.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20988",
    transform: "translate(9.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77517",
    className: "st8",
    d: "M1.5,0C1,0,0.5,0,0,0.1v1.7c0.9-0.2,1.8-0.3,2.7-0.3c1.3,0,2.5,0.2,3.7,0.6 C5.6,0.9,3.7,0,1.5,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20989"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77518",
    className: "st8",
    d: "M4.9,0c0.5,0,1,0,1.5,0.1v1.7C5.5,1.6,4.6,1.5,3.7,1.5C2.4,1.5,1.2,1.7,0,2.2 C0.7,0.9,2.6,0,4.9,0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77519",
    className: "st6",
    d: "M38.9,28.5c2.8-0.1,4.9-0.3,5.4-0.3c0.1-0.1,0.1-0.2,0.1-0.3c0,0-2.3,0.3-5.6,0.3 c-1.8,0.1-3.6-0.1-5.3-0.3c0,0.1,0.1,0.2,0.1,0.3C35.4,28.4,37.1,28.6,38.9,28.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20991",
    transform: "translate(41.053 18.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77520",
    className: "st3",
    d: "M0,2.4c0.7,0.9,1.7,1.5,2.9,1.5c1.6,0,2.7-0.6,3.1-2.1C5.3,0.8,4.2,0.1,3,0 C1.6,0,0.3,1,0,2.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_566",
    className: "st8",
    cx: 3.5,
    cy: 1.8,
    rx: 1.2,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77521",
    className: "st6",
    d: "M5.7,1.6C5.4,3.1,4.3,3.7,2.7,3.7C1.9,3.7,1.1,3.5,0.6,3c0.7,0.7,1.6,1.1,2.6,1.1 c1.6-0.2,2.7-0.8,2.8-2.4C5.7,1.5,5.6,1.4,5.7,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77522",
    className: "st8",
    d: "M2.7,1c1.1,0,2.2,0.3,3.2,0.8C5.4,0.7,4.2,0,3,0C1.5-0.1,0.2,1,0,2.4C0.7,1.6,1.7,1,2.7,1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20992",
    transform: "translate(31.565 18.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77523",
    className: "st3",
    d: "M5.9,2.4C5.3,3.3,4.2,3.9,3.1,3.8C1.5,3.8,0.4,3.2,0,1.8c0.7-1,1.7-1.7,2.9-1.8 C4.4,0,5.6,1,5.9,2.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_567",
    className: "st8",
    cx: 3.9,
    cy: 1.8,
    rx: 1.2,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77524",
    className: "st6",
    d: "M0.2,1.6c0.4,1.5,1.5,2.1,3.1,2.1c0.8,0,1.6-0.2,2.2-0.7C4.8,3.7,3.8,4.1,2.8,4.1 C1.1,3.9-0.1,3.3,0,1.8C0.2,1.5,0.3,1.4,0.2,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77525",
    className: "st8",
    d: "M3.2,1C2.1,0.9,1,1.2,0,1.8C0.6,0.7,1.7,0,2.9,0c1.5-0.1,2.8,0.9,3,2.4C5.2,1.6,4.3,1,3.2,1 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_77526",
    className: "st37",
    d: "M42.4,25.1c-0.2-1.1-1.1-1.9-2.2-2.1c-1.2,0.1-2.1,1-2.2,2.1c0,1.2,1.4,1.4,2.4,1.4 C41.3,26.4,42.4,26,42.4,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77527",
    className: "st14",
    d: "M39.2,10.8c5.7,0,8.7,3.4,9.2,4.7c0,0,1.7-4.2,0.7-7.6C47.9,3.1,44.2,0,37,0 C24.1,0,18.7,12.5,23.1,21.5l3.8-1.5C28.6,14.7,33.6,10.9,39.2,10.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20993",
    transform: "translate(26.219 10.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77528",
    className: "st15",
    d: "M13,0C6.8,0.1,1.5,4.4,0,10.3l0.7-0.3C2.4,4.7,7.3,0.9,13,0.8c5.7,0,8.7,3.4,9.2,4.7 c0,0,0.1-0.3,0.3-0.8C20.3,1.7,16.8-0.1,13,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_77529",
    className: "st15",
    d: "M31.5,11.3c0.6-0.5-0.2-2.8-1.2-5.4c-0.3-0.8-1.2-2.7-1.7-3.7c-6.5,4.1-8.8,12.4-5.5,19.3 l3.8-1.5c0.2-0.7,0.4-1.3,0.7-1.9c0-1.1-1.1-2.5-2.5-4.5c1.6,0.9,2.8,1,3.3,0.6c0.7-0.7-0.1-3.4-0.8-4.7 C29.7,11.8,31,11.7,31.5,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77530",
    className: "st16",
    d: "M49.1,7.6C47.7,3,44.1,0,37,0c-3.1-0.1-6.1,0.8-8.7,2.4C30,6,32,9.4,33.2,9 c1.5-0.5,1.6-2.1,1.3-4.8c0.7,3.7,1.8,4.1,2.7,4.1s2.3-2,2.3-4.8c0.2,3.4,0.7,5.4,1.9,5.5s2.7-0.8,4.1-3.3 c-0.9,2.9-1.2,3.9-0.3,4.5C45.9,10.6,47.4,9.7,49.1,7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77531",
    className: "st15",
    d: "M49.2,7.9c-0.1-0.2-0.1-0.4-0.2-0.6c-1.3,2.5-2,4.5-1.5,5.1c0.3,0.3,1,0.3,1.7,0.1 C49.6,10.9,49.5,9.4,49.2,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77532",
    className: "st35",
    d: "M15.6,99c0.7-3.1,3.1-6.3,4.9-8.9c0.6-1,1.4-1.9,2.3-2.6c1.9-1.2,5.5-1.3,7.7-0.8 c4.7,1.1,4.1,6.7,6.2,10c0.7,1.1,2.2,3.9,0.3,4.3c-2.9,0.6-3-2.6-3.8-4.5c-0.4-0.6-0.7-1.2-0.9-1.8c-0.2-1.1-0.1-2.3-0.2-3.4 c-0.2-1.1-0.3-3.1-1.6-3.5s-4.1,0.4-5.2,0.9c-2.4,1.1-3.2,2.4-4.1,4.9c-0.8,2.4-1.3,4.9-2.1,7.3C18.2,101.1,14,99.9,15.6,99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77533",
    className: "st35",
    d: "M19.7,102.7c-0.6-1.6,0.5-3.9,0.7-5.5c0.2-1.4,2-5,2.7-6.2c1-1.7,2.5-3.2,4.2-4.2 c1.2,0.5,2.1,0,3,1c1,1,1.1,3,1.3,4.3c0.2,1.5,0.5,3.1,0.6,4.6c0.2,1.2,0.2,2.4,0,3.6c-0.5-0.6-1.3-0.3-1.6-0.7 c-0.5-0.5-0.4-2-0.4-2.8c-0.1-1.7,0.4-5.4-1.4-6.6c-1.2-0.9-2.9-0.7-3.8,0.5c-0.1,0.1-0.2,0.3-0.3,0.5c-1.2,2.4-1.8,5.1-1.8,7.8 C22.7,101,20.8,103.8,19.7,102.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77534",
    className: "st35",
    d: "M23.5,100.1c-0.6-1.6,0.5-3.9,0.7-5.5c0.1-1.3,0.5-2.6,1.1-3.8c1-1.7,2.5-3.2,4.2-4.2 c1.2,0.5,2.1,0,3,1c1,1,1.1,3,1.3,4.3c0.2,1.5,0.5,3.1,0.6,4.6c0.2,1.2,0.2,2.4,0,3.6c-0.5-0.6-1.3-0.3-1.6-0.7 c-0.5-0.5-0.4-2-0.4-2.8c-0.1-1.7,0.4-5.4-1.4-6.6c-1.2-0.9-2.9-0.7-3.8,0.5c-0.1,0.1-0.2,0.3-0.3,0.5c-1.3,2.4-1.1,5-1.2,7.6 C25.6,100.6,24.6,101.2,23.5,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77535",
    className: "st6",
    d: "M40.2,25.9c-0.8,0-1.6-0.3-2.2-0.8c0,0.1,0,0.2,0,0.3c0,0.9,1,1.6,2.2,1.6s2.2-0.7,2.2-1.6 c0-0.1,0-0.2,0-0.3C41.8,25.6,41,25.9,40.2,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77536",
    className: "st5",
    d: "M34.3,88.5c-0.4-0.7-2-2.5-2.8-3.5s-2-1-3.4-0.9s-5.8,0.9-6,1s-4.3-5.7-6.2-9.1 c-1.9-3.1-4.1-6-6.4-8.8l2-2.8c-1.7-1-3.4-2.1-5-3.3C6.4,61,6.3,61,6.2,61c-0.7-0.4-1.4-0.9-2.1-1.4c-1.3,1.9-2.5,4-3.6,6.1 c-0.5,1.3-0.7,1.8,0,3.1s5.6,8.4,9,11.6s8.7,7.3,9.5,8.2s1.8,1.9,2.6,2s3.5,0,3.5,0c0.5,0.7,1,1.5,1.5,2.3 c0.7,1.3,1.7,0.7,1.5,0.1s-0.7-2.3-0.7-2.3s0.9,1.5,1.3,2c0.8,1.1,1.6,0.8,1.5,0.2c-0.2-0.8-0.4-1.5-0.7-2.3 c0.3,0.7,0.7,1.4,1.2,1.9c0.9,0.9,1.7,0.3,1.5-0.2s-0.5-1.8-0.9-2.7s-1.5-2.8-1.5-2.8c0.9,1.1,2,2.1,3.1,3 C34,90,34.6,89.1,34.3,88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77537",
    className: "st34",
    d: "M78.4,28.8c1.1,2.7,3.5,4.5,4.1,7.4c0.6,3.2,0,6.8,0,10c0,7.7-0.5,15.5-1.1,23.2 c-0.4,5.4,0,10.8-0.6,16.2c-0.2,1.8-0.2,3.6-0.3,5.4c0,0.7-0.4,1.9,0,2.5c0.4,0.6,2.5,0.7,3.1,0.5c1.3-0.6,1-3.3,1-4.5 c0-3.8-0.1-7.6-0.1-11.4c0-3-0.1-6-0.1-9.1c0-3.2,0.6-6.5,0.6-9.7c0-4.7-0.2-9.4-0.3-14.1c0-2.2-0.2-4.4-0.4-6.6 c-0.1-1.9,0.1-4.2-0.8-5.9c-0.8-1.3-1.8-2.4-2.9-3.4c-0.3-0.3-0.6-0.8-1-1c-0.5-0.2-0.9,0-1.4-0.3C78,28.1,77.6,28.8,78.4,28.8z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    transform: "translate(6.597 -27.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_467"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    x: 405.3,
    y: 327.1,
    className: "st38",
    width: 10.1,
    height: 7.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    x: 460.4,
    y: 327.1,
    className: "st38",
    width: 10.1,
    height: 7.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    x: 515.5,
    y: 327.1,
    className: "st38",
    width: 10.1,
    height: 7.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    x: 570.6,
    y: 327.1,
    className: "st38",
    width: 10.1,
    height: 7.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_451",
    className: "st2",
    d: "M404,279.8h177.7c0.6,0,1.2,0.5,1.2,1.2v45.2c0,0.6-0.5,1.2-1.2,1.2H404 c-0.6,0-1.2-0.5-1.2-1.2V281C402.8,280.3,403.3,279.8,404,279.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    className: "st24",
    d: "M581.7,279.8H403.9c-0.6,0-1.1,0.5-1.1,1.1l0,0v8.9h180v-8.9 C582.8,280.3,582.3,279.8,581.7,279.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_452",
    className: "st2",
    d: "M399.5,261.4h184.2c5.7,0,10.3,4.6,10.3,10.3v1.4c0,5.7-4.6,10.3-10.3,10.3H399.5 c-5.7,0-10.3-4.6-10.3-10.3v-1.4C389.2,266,393.8,261.4,399.5,261.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    className: "st24",
    d: "M399.5,280.9c-4.3,0-7.8-3.5-7.8-7.8v-1.4c0-4.3,3.5-7.8,7.8-7.8h184.2 c4.3,0,7.8,3.5,7.8,7.8v1.4c0,4.3-3.5,7.8-7.8,7.8H399.5z M583.7,279.1c3.3,0,6-2.7,6-6v-1.4c0-3.3-2.7-6-6-6H399.5 c-3.3,0-6,2.7-6,6v1.4c0,3.3,2.7,6,6,6H583.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    className: "st24",
    cx: 400.4,
    cy: 272.4,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    className: "st24",
    cx: 582.9,
    cy: 272.4,
    r: 6.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_469"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    x: 411.9,
    y: 266.8,
    className: "st24",
    width: 1.1,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    x: 431.8,
    y: 266.8,
    className: "st24",
    width: 1.1,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    x: 451.7,
    y: 266.8,
    className: "st24",
    width: 1.1,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_456",
    x: 471.5,
    y: 266.8,
    className: "st24",
    width: 1.1,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_457",
    x: 491.4,
    y: 266.8,
    className: "st24",
    width: 1.1,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_458",
    x: 511.3,
    y: 266.8,
    className: "st24",
    width: 1.1,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    x: 531.1,
    y: 266.8,
    className: "st24",
    width: 1.1,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    x: 551,
    y: 266.8,
    className: "st24",
    width: 1.1,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_461",
    x: 570.9,
    y: 266.8,
    className: "st24",
    width: 1.1,
    height: 10.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    className: "st22",
    d: "M583.7,265.7H399.5c-3.3,0-6,2.7-6,6v1.4c0,1.9,0.9,3.7,2.4,4.8c-0.1-0.9-0.1-1.9-0.1-2.8 c-0.3-0.6-0.5-1.3-0.5-2v-1.4c0-2.3,1.9-4.2,4.2-4.2h184.2c2.3,0,4.2,1.9,4.2,4.2v1.4c0,0,0,0.1,0,0.1c0,0.2,0,0.4-0.1,0.6 c0,0.3-0.1,0.6-0.2,0.8c-0.3,1.2-0.6,2.5-1,3.7c1.9-1.1,3.1-3.1,3.1-5.3v-1.4C589.8,268.4,587.1,265.7,583.7,265.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    className: "st22",
    cx: 400.4,
    cy: 272.4,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    className: "st22",
    cx: 582.9,
    cy: 272.4,
    r: 2.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgButcher);
export default __webpack_public_path__ + "static/media/img-butcher.3a77026426b9f0458ea63bd9e651664f.svg";
export { ForwardRef as ReactComponent };